<template>
  <div class="hello">
    <div class="foote">
      <div class="shopCar">
        <div class="shopTop">
          <p>我的购物车</p>
          <div class="rightBt" @click="goBuy">
            <span>继续购买 ></span>
          </div>
        </div>
        <div class="shopCars">
          <div class="table">
            <div class="radio">
              <div class="select" @click="allEvent()">
                <img v-if="!allSelect" src="../assets/image/selects.png" alt="">
                <img v-else src="../assets/image/selects_active.png" alt="">
              </div>
              <div class="selec_name">
                <span>全部</span>
              </div>
            </div>
            <div class="goods_name">
              <span>商品名称</span>
            </div>
            <div class="price">
              <span>价格（元）</span>
            </div>
            <div class="number">
              <span>数量</span>
            </div>
            <div class="all">
              <span>小计（元）</span>
            </div>
          </div>
          <div class="shop_goods">
            <div class="carsList" v-for="(item,index) in carArr" :key="index">
              <div class="radio">
                <div class="select_bot" @click="selectA(index)">
                  <img v-if="!item.isActive" src="../assets/image/selects.png" alt="">
                  <img v-else src="../assets/image/selects_active.png" alt="">
                </div>
                <div class="goods_img">
                  <img :src="item.spec_pic" alt="">
                </div>
              </div>
              <div class="goods_name">
                <div class="goods_title">{{item.goods_title}}</div>
                <div class="goods_desc">套餐：{{item.spec_name}}</div>
              </div>
              <!-- 价格 -->
              <div class="price">
                <div class="price_all">
                  <span>{{item.spec_price}}</span>
                </div>
              </div>
              <!-- 数量 -->
              <div class="number">
                <div class="addNumber">
                  <div class="reduce" @click="reduceEvent(index,item.goods_num)">
                    <img  src="../assets/image/reduce.png" alt="">
                  </div>
                  <div class="num">
                    {{item.goods_num}}
                  </div>
                  <div class="add" @click="addEvent(index,item.goods_num)">
                    <img src="../assets/image/addr.png" alt="">
                  </div>
                </div>
              </div>
              <!-- //小计 -->
              <div class="all">
                <div class="price_all">
                  <span>{{item.total_price}}</span>
                </div>
              </div>
            </div>
          </div>




        </div>
        <div class="shopsuB">
          <div class="daido" @click="allEvent()">
            <img v-if="!allSelect" src="../assets/image/selects.png" alt="">
            <img v-else src="../assets/image/selects_active.png" alt="">
          </div>
          <div class="alls">
            <span>全选</span>
          </div>
          <div class="alls del" @click="delEvent()">
            <span>删除</span>
          </div>
          <div class="right">
            <div class="right_title">
              <span>已选商品{{carArr.length}}件，合计：</span>
            </div>
            <div class="right_price">
              ￥<span>{{all_price}}</span>
            </div>
            <div class="right_btn" @click="goShop()">
              立即购买
            </div>
          </div>
        </div>


      </div>
      <div style="height: 400px;"></div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        allSelect: false,
        carArr: [],
        all_price: 0,
        arr: [],
        allCar: []
      }
    },
    created() {
      this.ajaxFun();
    },
    methods: {
      ajaxFun() {
        this.$fetch('/cart/list').then(res => {
          res.data.forEach(item => {
            item.total_price = parseFloat(item.total_price).toFixed(2);
            item.isActive = false;
          })
          this.carArr = res.data;
        })
      },
      //全选
      allEvent() {
        this.allSelect = !this.allSelect;
        this.carArr.forEach(item => {
          if (this.allSelect) {
            item.isActive = true;
           this.arr.push(item);
            this.all_price = this.arr.reduce((count, item) => count + parseFloat(item.total_price), 0).toFixed(2)
          } else {
            item.isActive = false;
            this.all_price = 0;
            this.arr = [];
          }
        })
      },
      // 加
      addEvent(index, num) {
		 let goods_id = this.carArr[index].goods_id;
		 let spec_id = this.carArr[index].spec_id;
		 let goods_num = 1;
        this.carArr[index].goods_num += 1;
        this.carArr[index].total_price = parseFloat(this.carArr[index].goods_num * this.carArr[index].spec_price).toFixed(
          2);

        if (this.allSelect) {
          this.all_price = this.allCar.reduce((count, item) => count + Number(item.total_price), 0).toFixed(2);
        } else {
          if (this.carArr[index].isActive) {
            this.all_price = this.arr.reduce((count, item) => count + Number(item.total_price), 0).toFixed(2)
          }
        }
	
		let params = {
			goods_id:goods_id,
			spec_id:spec_id,
			goods_num:goods_num
		}
		this.$post('cart/edit',params).then(res => {});
      },
      // 减
      reduceEvent(index, num) {
		  let goods_id = this.carArr[index].goods_id;
		  let spec_id = this.carArr[index].spec_id;
		  let goods_num = -1;
		  
        this.carArr[index].goods_num -= 1;
        if (this.carArr[index].goods_num <= 0) {
          this.carArr[index].goods_num = 1;
			
        }
        this.carArr[index].total_price = parseFloat(this.carArr[index].goods_num * this.carArr[index].spec_price).toFixed(
          2);
        if (this.allSelect) {
          this.all_price = this.allCar.reduce((count, item) => count + Number(item.total_price), 0).toFixed(2)
        } else {
          if (this.carArr[index].isActive) {
            this.all_price = this.arr.reduce((count, item) => count + Number(item.total_price), 0).toFixed(2)
          }
        }
		let params = {
			goods_id:goods_id,
			spec_id:spec_id,
			goods_num:goods_num
		}
		let that = this;
		this.$post('cart/edit',params).then(res=>{
			if(res.code == 200){
				if(that.carArr[index].goods_num <= 1){
						window.location.reload();
				}
			}
		});
      },
      // 列表选择 已选择 才可以支付
      selectA(index) {
        this.carArr[index].isActive = !this.carArr[index].isActive;
        if (this.carArr[index].isActive == true) {
          this.arr.push(this.carArr[index]);
        } else {
          for (var i = 0; i < this.arr.length; i++) {
            if (!this.arr[i].isActive) {
              this.arr.splice(i, 1)
            }
          }
        }
        this.all_price = this.arr.reduce((count, item) => count + Number(item.total_price), 0).toFixed(2);
        if (this.carArr.findIndex(item => item.isActive === false) == -1) {
          this.allSelect = true;
          this.allCar.reduce((count, item) => count + Number(item.total_price), 0).toFixed(2);
        } else {
          this.allSelect = false;
        }
      },
      delEvent() {
        var arr = [];
        this.arr.forEach(item => {
          var obj = {};
          obj.goods_id = item.goods_id;
          obj.spec_id = item.spec_id;
          arr.push(obj);
        })
        var data = {
          goodsJson: JSON.stringify(arr)
        }
        if(this.arr.length <= 0){
          this.$message.error('请选择商品')
        }else{
          this.$post('cart/del', data).then(res => {
            if (res) {
              this.arr = [];
              this.all_price = 0;
              if(this.arr.length <= 0){
                this.allSelect = false;
              }
              this.$message.success('删除成功');
              this.ajaxFun();
            }
          })
        }

      },
      // 立即购买
      goShop() {
        var carArr = [];

        for (var i = 0; i < this.carArr.length; i++) {
          if (this.carArr[i].isActive) {
            carArr.push(this.carArr[i]);
          }
        }
        var len = this.carArr.filter(item => item.isActive == true);
        if (len.length <= 0) {
          this.$message.error('请选择商品');
          return
        }

        localStorage.setItem('carArr', JSON.stringify(carArr));
        localStorage.setItem('all_price', this.all_price);

        this.$router.push({
          path: '/information',
          query: {
            isCar: 1
          }
        })

      },
      goBuy(){
        this.$router.push({
          path:'/shopDetail',
          query:{
            category_id:0
          }
        })
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/shopCar.css");
</style>



// WEBPACK FOOTER //
// src/pages/shopCar.vue